//@ts-check
import axios from 'axios';

import { getAccessToken, setAccessToken } from '@/lib/authToken.js';
import { API_BASE_URL } from '@/lib/constants.js';

/** Axios instance for VMS API calls. */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** @type {Promise<string>|null} */
let refreshPromise = null;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (!original || error.response?.status !== 401 || original._retry) {
      return Promise.reject(error);
    }

    const url = String(original.url ?? '');
    if (url.includes('/auth/login') || url.includes('/auth/refresh')) {
      return Promise.reject(error);
    }

    original._retry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = apiClient
          .post('/auth/refresh', {})
          .then((res) => {
            const token = res.data.accessToken;
            setAccessToken(token);
            return token;
          })
          .finally(() => {
            refreshPromise = null;
          });
      }

      const token = await refreshPromise;
      original.headers.Authorization = `Bearer ${token}`;
      return apiClient(original);
    } catch (refreshErr) {
      setAccessToken(null);
      return Promise.reject(refreshErr);
    }
  },
);
